import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/**
 * Barre gold is the action color on this page (5:1+ against plum).
 * Coral is reserved for tension (pain marks, price rise, the "without" column).
 */
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-4 text-lg md:text-xl rounded-lg min-h-[60px]' : 'px-5 py-3 text-sm rounded-md';
  return <a href={href} className={`inline-flex w-full items-center justify-center text-center gap-2 bg-gold hover:bg-gold-hover text-gold-ink font-display font-semibold uppercase tracking-wide shadow-card hover:shadow-lift active:scale-[0.98] transition-[background-color,box-shadow,transform] duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-white/60 ${sizing} ${className}`} data-id="element-78" data-mp="lkxt4iwp3sq9">
      {children}
    </a>;
}